import { useTranslation } from "react-i18next";
import { Link, Outlet, useLocation } from "react-router-dom";
import "./mypage.scss";

export default function MyInfLayout() {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  return (
    <div className="my-layout">
      <aside className="my-menu">
        <h2 className="text-blue-300">{t("nav_ttl")}</h2>
        <ul>
          <li className={pathname === "/mypage" ? "text-blue-300" : ""}>
            <Link to="">{t("nav_lst_inf")}</Link>
          </li>
          <li
            className={pathname.includes("/mypage/resv") ? "text-blue-300" : ""}
          >
            <Link to="/mypage/resv">{t("nav_lst_bk")}</Link>
          </li>
          {/* <li className={pathname === "/mypage/hotels" ? "text-blue-300" : ""}>
            <Link to={"mypage/hotels"}>{t("nav_lst_htl")}</Link>
          </li>
          <li>
            <Link to="mypage/sns">{t("nav_lst_sns")}</Link>
          </li> */}
        </ul>
      </aside>
      <Outlet />
    </div>
  );
}
